import React from 'react';
import {
  Mdiv,
  Mh2,
  Mul,
  Mli,
  MButtonContainer,
  MImage,
} from '../component/Menu/MenuComponents';
import Manual1 from '../assets/manual1.png';
import {
  MSiguienteButtom,
  MAnteriorButtom,
} from '../component/Buttons/Bottons';
import { useHistory } from 'react-router-dom';

const ManualUsuario1 = () => {
  const nav = useHistory();

  function nextPage() {
    nav.push('/manual2');
  }

  function backPage() {
    nav.push('/manual');
  }

  return (
    <div
      style={{
        maxHeight: '500px',
        minHeight: '100%',
        maxWidth: '100%',
        paddingRight: '40px',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Mdiv>
        <Mh2>Pestaña Principal (Inicio)</Mh2>
        <Mul>
          <Mli>5. Filtra por estatus.</Mli>
          <Mli>6. Iniciales autogeneradas del nombre de la emisora.</Mli>
        </Mul>
      </Mdiv>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <MImage src={Manual1} alt="imagen 2" />
      </div>

      <MButtonContainer>
        <MSiguienteButtom
          onClick={nextPage}
          Text="Siguiente"></MSiguienteButtom>

        <MAnteriorButtom onClick={backPage} Text="Anterior"></MAnteriorButtom>
      </MButtonContainer>
    </div>
  );
};

export default ManualUsuario1;
